import React from "react";
import Text from "features/components/text";
import {__} from "services/i18n";

const Loading = () => {
    return <div className="loading">
        <Text size={18} align={"center"}>{__("common.loading")}</Text>
    </div>
};
export default Loading;